import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/parametros';

import Select from 'react-select';

import {api} from '../../actions/_request';


const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);
const Actualizar = [
    {label: 'Precio', value: 1},
    {label: 'Costo', value: 2},
   
];
const Metodos = [
    {label: 'UEPS', value: 1},
    {label: 'PEPS', value: 2},
   
];


class ParamtrosModal extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            impuesto: {
                id:0,
                f_precios:'999,999,999.99',
                actualizar:1,
                metodo_costeo:1, 
                decimales_cantidades:2,                         
            },
            action: 'save',
            activeTab: '1',
            modal:false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.toggle_tab= this.toggle_tab.bind(this);
        this.handleSelectChange= this.handleSelectChange.bind(this);
                 
    }
   
    handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
            impuesto: {
                ...this.state.impuesto,
                [name]: value
            }
        });
    }

     toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

      componentWillReceiveProps(nextProps)
    {
           // let self = this;
           //  api().get(`plazos_vencimientos/1`)
           //  .then(function(response)
           //  {
                  
           //      if(response.status === 200)
           //      {                
           //          self.setState({
           //              impuesto: response.data,
           //              action: 'update'
           //          });

           //      }

           //  });
    }

    componentDidMount()
    {
            let self = this;
            api().get(`parametros/1`)
            .then(function(response)
            {
                  
                if(response.status === 200)
                {                
                    self.setState({
                        impuesto: response.data,
                        action: 'update',
                        almacen_codigo:response.data.almacen.codigo,
                        almacen_descripcion:response.data.almacen.nombre
                    });

                }

            });
        
       
    }

   

    resetModal(){
        this.setState({
            impuesto: {
                 id:0,               
               cc1:0,
               cc2:0,
               cc3:0,
               cc4:0,
               cc5:0,
               cc6:0,
               cp1:0,
               cp2:0,
               cp3:0,
               cp4:0,
               cp5:0,
               cp6:0,

            },
            action: 'save',
             activeTab: '1',
        });
        
    }

    



    handleInputChange(event) {
        let {impuesto} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        // if(target.type === 'checkbox'){
        //     value='0';
        //     if(target.checked)
        //         value='1';
        // }

        impuesto[name] = value;
     
        this.setState({
            impuesto : impuesto
        });
    }

    objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     
                         objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }
   
   

    handleSubmit(evt)
    {
        evt.preventDefault();
        let {impuesto} = this.state;
        let action=this.state.action;
        
        let save=true;
        let dato="";
        let self = this;        

        if(save){

            

              
                        this.props[action](impuesto, (data) => {
                        swal({
                            title: 'Parametros',
                            text: 'Parametros Guardados correctamente!',
                            type: 'success',
                            // showCancelButton: true,
                            // confirmButtonColor: '#3085d6',
                            // cancelButtonColor: '#d33',
                            confirmButtonText: 'Continue!'
                        }).then((result) => {
                            if (result.value) {
                              
                               
                               
                                self.props.toggle();
                                self.resetModal();
                            }
                        })
                    });

                
            

           


         

        }else{
            swal("Oops..", "Por favor Verificar el Campo de " +dato);

        }

        


        

      

    }

    render()
    {

        let {impuesto}=this.state;
  
        
        return(

           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal-80 modal_cliente">
                <form >
                <ModalHeader toggle={this.props.toggle}>Parametros de Sistema</ModalHeader>
                <ModalBody>
                     <Nav tabs>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => { this.toggle_tab('1'); }}
                        >
                          Especiales
                        </NavLink>
                      </NavItem>
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                      <TabPane tabId="1">
                        <Row>
                          <Col sm="12">

                          <div className="row mt-3 form_cliente">
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Formato para Precios</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="f_precios"
                                    
                                    value={impuesto.f_precios}
                                    onChange={ this.handleInputChange}  />

                            </FormGroup>
                        </div>
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Decimales en Cantidades</Label>
                                    <Input
                                    placeholder=""
                                    type="text"
                                    name="decimales_cantidades"
                                    maxLength={1}
                                    value={impuesto.decimales_cantidades}
                                    onChange={ this.handleInputChange}
                                    />
                            </FormGroup>
                        </div>
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Act. Precios</Label>
                                    <Select
                                    placeholder=""
                                    type="text"
                                    name="actualizar"
                                    options={Actualizar}
                                    value={parseInt(impuesto.actualizar)}
                                      onChange={ (select) => { this.handleSelectChange(select, 'actualizar') } }
                                    clearable={false}
                                />
                            </FormGroup>
                        </div>
                        <div className="col-md-3">
                            <FormGroup>
                                <Label>Metodo Costeo</Label>
                                    <Select
                                    placeholder=""
                                    type="text"
                                    name="metodo_costeo"
                                    options={Metodos}
                                    value={parseInt(impuesto.metodo_costeo)}
                                     onChange={ (select) => { this.handleSelectChange(select, 'metodo_costeo') } }
                                    clearable={false}
                                />
                            </FormGroup>
                        </div>
                       



                        </div>
                         <div className="row mt-2">
                           <div className="col-md-6">
                                    <div className="row">
                                    <div className="col-md-12 pt-2">
                                            <div className="form-group mt-4 text-right ajuste_checkbox_parametros">
                                                <label className="d-block"> Modificar Folio de Factura al Capturar
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="modificar_folio" 
                                                    checked={impuesto.modificar_folio }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Facturar sin existencias
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="facturar_sin_existencias" 
                                                    checked={impuesto.facturar_sin_existencias }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block">Cambiar precios al facturar
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="cambiar_precios_factura" 
                                                    checked={impuesto.cambiar_precios_factura }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Modificar tipo de cambio al facturar
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="modificar_tipo_cambio_factura" 
                                                    checked={impuesto.modificar_tipo_cambio_factura }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Cambiar descuentos
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="cambiar_descuentos" 
                                                    checked={impuesto.cambiar_descuentos }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Cambiar impuestos  en movtos. de ventas
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="cambiar_impuestos_ventas" 
                                                    checked={impuesto.cambiar_impuestos_ventas }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Manejar intermediariosen ventas
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="intermediarios_ventas" 
                                                    checked={impuesto.intermediarios_ventas }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Agregar 2da. Desc. articulos de ventas
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="segunda_descripcion_articulos" 
                                                    checked={impuesto.segunda_descripcion_articulos }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Permitir modificar plazo de pago en ventas
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="modificar_plazo_pago" 
                                                    checked={impuesto.modificar_plazo_pago }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> preguntar por impresora en facturas
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="impresora_factura" 
                                                    checked={impuesto.impresora_factura }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block">Cambio de moneda en compra
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="cambio_moneda_compra" 
                                                    checked={impuesto.cambio_moneda_compra }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block">Impresion directa de factura electronica
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="impresion_factura" 
                                                    checked={impuesto.impresion_factura }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                       
                                        

                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                    <div className="row">
                                    <div className="col-md-12 pt-2">
                                            <div className="form-group mt-4 text-right ajuste_checkbox_parametros">
                                                <label className="d-block"> Verificar saldos al facturar
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="saldos_factura" 
                                                    checked={impuesto.saldos_factura }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Redondear centavos en factura de venta
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="redondear_centavos" 
                                                    checked={impuesto.redondear_centavos }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block">Desglosar facturas por pedimentos
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="facturas_pedimentos" 
                                                    checked={impuesto.facturas_pedimentos }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block">ver datos del cliente al facturar
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="datos_cliente_factura" 
                                                    checked={impuesto.datos_cliente_factura }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Permitir modificar facturas de ventas
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="modificar_facturas_ventas" 
                                                    checked={impuesto.modificar_facturas_ventas }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> usar Intermediarios
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="intermediarios" 
                                                    checked={impuesto.intermediarios }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Permitir modificar facturas de compra
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="modificar_facturas_compra" 
                                                    checked={impuesto.modificar_facturas_compra }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Cambiar impuestos en movtos. de compras
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="cambiar_impuestos_compras" 
                                                    checked={impuesto.cambiar_impuestos_compras }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Generar abono automatico en facturas de contado
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="abono_facturas_contado" 
                                                    checked={impuesto.abono_facturas_contado }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block">Aplicar abonos directos al saldo del cliente
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="abono_cliente" 
                                                    checked={impuesto.abono_cliente }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Preguntar por TC en cada Reg de Fact.
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="preguntar_tc_factura" 
                                                    checked={impuesto.preguntar_tc_factura }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> imprimir numero de corte
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="imprimir_numero_corte" 
                                                    checked={impuesto.imprimir_numero_corte }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                                <label  className="d-block"> Precios en base a moneda de compra
                                                &nbsp;&nbsp;
                                                    <input type="checkbox"
                                                    name="precios_moneda_compra" 
                                                    checked={impuesto.precios_moneda_compra }
                                                    onChange={this.handleInputChange}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                        <div className="row text-right ajuste_checkbox_parametros">
                                        <div className="col-md-10 mt-2">
                                          <Label className="d-inline">Numero de Orden de Facturas</Label>
                                        </div>
                                        <div className="col-md-2">
                                        <Input
                                                    placeholder=""
                                                    type="number"
                                                    name="numero_ordenes_factura"
                                                    value={impuesto.numero_ordenes_factura}
                                                    onChange={ this.handleInputChange}
                                                    />
                                        </div>
                                        </div>
                                            
                                        </div>
                                       
                                        

                                        </div>

                                    </div>



                                   
                          </div>



                         
                     
                                                   
                          </Col>
                        </Row>
                      </TabPane>                      
                    </TabContent>
                    
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.parametros.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.handleSubmit} >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        parametros : state.parametros,
    }
};

export default connect(mapStateToProps, actions)(ParamtrosModal)


// WEBPACK FOOTER //
// ./src/components/parametrossistema/modal.js